// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ImageUtils = require("./imageUtils");
var Core__Nullable = require("@rescript/core/src/Core__Nullable.bs.js");

function resize(maxWidth, maxHeight, file) {
  return ImageUtils.resize(file, Core__Nullable.fromOption(maxWidth), Core__Nullable.fromOption(maxHeight));
}

function _getCroppedImage(prim0, prim1) {
  return ImageUtils.getCroppedImg(prim0, prim1);
}

var getCroppedImage = _getCroppedImage;

exports.getCroppedImage = getCroppedImage;
exports.resize = resize;
/* ./imageUtils Not a pure module */
